import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import sendRequest from "../../helpers/ajax";
import IListResults from "../../types/IListResults";
import IMessageHeader from "../../types/IMessageHeader";
import IRecipient from "../../types/IRecipient";
import IRecipientSearchRequest from "../../types/IRecipientSearchRequest";
import IResponse from "../../types/IResponse";
import MessageDetail from "./MessageDetail";

interface IMessageDetailContainerState {
    loading: boolean;
    loadingRecipients: boolean;
    id: number;
    messageType: string;
    message: IMessageHeader;
}

class MessageDetailContainer extends React.Component<RouteComponentProps<any>, IMessageDetailContainerState> {

    private unmounting: boolean = false;

    constructor(props: RouteComponentProps<any>) {
        super(props);

        this.state = {
            loading: false,
            loadingRecipients: true,
            id: this.props.match.params.messageID,
            messageType: this.props.match.params.messageType,
            message: {
                clientHeaderID: 0, dateTimeCreated: "", referenceID: "", messageContent: "", isHtmlFormat: false,
                description: "", messageType: "", from: "", hasAttachments: false, id: 0, subject: "", isTest: false,
                machineAnswerTextToSay: "", responses: "", responseTextToSay: "", soundFileID: "", statusChangePostURL: "",
                uniqueID: "", utcScheduledDateTime: "", voiceID: "", attachments: []
            }
        };

        this.loadMessage = this.loadMessage.bind(this);
        this.searchRecipients = this.searchRecipients.bind(this);
    }

    public render() {
        return <MessageDetail loading={this.state.loading}
            message={this.state.message}
            loadingRecipients={this.state.loadingRecipients}
            searchRecipients={this.searchRecipients}
        />;
    }

    public async componentDidMount() {
        await this.loadMessage();
    }

    public componentWillUnmount(){
        this.unmounting = true;
    }

    private async loadMessage() {

        this.setState({ loading: true });

        const response = await sendRequest<IResponse<IMessageHeader>>(`/api/message/getbyid/${this.state.id}/${this.state.messageType}`, "GET");

        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ message: response.payload });
        }
    }

    private async searchRecipients(request: IRecipientSearchRequest): Promise<IResponse<IListResults<IRecipient>> | null> {
        this.setState({ loadingRecipients: true });

        const response = await sendRequest<IResponse<IListResults<IRecipient>>>(`/api/message/searchrecipients`, "POST", request);

        if (this.unmounting){
            return null;
        }

        this.setState({ loadingRecipients: false });

        return response;
    }
}

export default withRouter(MessageDetailContainer);



// WEBPACK FOOTER //
// ./src/components/MessageDetail/MessageDetailContainer.tsx